import { JSX } from 'react';
import {
    List,
    Datagrid,
    TextField,
    ShowButton,
    EditButton,
    TextInput,
    ReferenceField,
    TopToolbar,
    CreateButton,
    FilterButton,
    ExportButton,
    UrlField
} from 'react-admin';

const urlFilters: JSX.Element[] = [
    <TextInput label="Id" source="id" name="Id" />,
    <TextInput label="Path" source="path" name="path" />
];

const ListActions: () => JSX.Element = (): JSX.Element => {
    return(
        <TopToolbar>
            <CreateButton />
            <FilterButton />
            <ExportButton />
        </TopToolbar>
    );
}

export const AdminUrlList: () => JSX.Element = (): JSX.Element => {
    return (
        <List
            actions={<ListActions/>}
            filters={urlFilters}>
            <Datagrid bulkActionButtons={false}>
                <TextField source="id"/>
                <UrlField source="path" target="_blank"/>
                <ReferenceField
                    source="website"
                    reference="websites"
                    link="show"
                >
                    <TextField source="baseUrl" />
                </ReferenceField>
                <>
                    <ShowButton/>
                    <EditButton/>
                </>
            </Datagrid>
        </List>
    );
}